import { render, staticRenderFns } from "./Aulic.vue?vue&type=template&id=394b08fe&"
import script from "./Aulic.vue?vue&type=script&lang=js&"
export * from "./Aulic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports